// Copyright (c) Docugami, Inc. All rights reserved.

import { DgButton, DgInputBox } from "components/common/DgCommonStyledComponents";
import { useKeyPressHandler } from "hooks/KeyPressHandler";
import React, { useState } from "react";
import styled from "styled-components"
import { ExplorerTextButton } from "./ExplorerStyles";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 30px;
`

const InputBox = styled(DgInputBox)`
    font-size: 36px;
    line-height: 24px;
    font-weight: 900;
`

const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 30px;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
`

interface EntryBoxProps {
    placeholder: string;
    disabled: boolean;
    maxLength?: number;
    onConfirm: (value: string) => void;
    onCancel?: () => void;
}

export const EntryBox = (props: EntryBoxProps): JSX.Element => {
    const [value, setValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    useKeyPressHandler(isFocused ? 'Enter' : undefined, confirm);

    function isValid() {
        return !!value.trim();
    }

    function confirm() {
        if (!isValid()) {
            return;
        }

        props.onConfirm(value.trim());
    }

    return (
        <Container>
            <InputBox autoFocus={true} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} maxLength={props.maxLength} disabled={props.disabled} placeholder={props.placeholder} value={value} onChange={e => setValue(e.target.value)} />
            <ButtonsContainer>
                {!!props.onCancel && <ExplorerTextButton onClick={props.onCancel}>Cancel</ExplorerTextButton>}
                <DgButton onClick={confirm} disabled={!isValid()}>OK</DgButton>
            </ButtonsContainer>
        </Container>
    )
}
